import * as React from "react";
import { endOfDay, format } from "date-fns";

import { CalendarIcon, CamIcon, HospitalIcon } from "../../shared/svgIcon";
import {
  cn,
  dateConvert,
  useAppointmentsMiscellaneous,
} from "../../shared/utils";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { useRef } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAvailDates, getAvailSlots } from "../../lib/api";
import { useStore } from "../../store";

export function AppointmentForm(props) {
  let navigate = useNavigate();
  const { locationId: id } = useParams();
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();
  const selectedAppointment = useStore((state) => state.selectedAppointment);
  const setSelectedAppointment = useStore((state) => state.setAppointment);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
  const selectedDateRef = useRef(null);
  const selectedTimeRef = useRef(null);
  const [availDates, setAvailDates] = React.useState([]);
  const [timeSlot, setTimeSlots] = React.useState([]);
  const [currentDoctor, setCurrentDoctor] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [selectedType, setSelectedType] = React.useState(selectedAppointment?.appointment_type || '');

  const [locationDetail, setLocationDetail] = React.useState(null);
  useEffect(() => {
    if (!id) return;
    // console.log(id, "id");
    const currentDoctor = sessionStorage.getItem("selectedDoctor")
      ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
      : null;
    const currentLocation = sessionStorage.getItem("selectedLocation")
      ? JSON.parse(sessionStorage.getItem("selectedLocation"))
      : null;
    setLocationDetail(currentLocation);
    setCurrentDoctor(currentDoctor);
    fetchAvailDates(id);
  }, [id]);
  const fetchAvailDates = async (orgId) => {
    const currentDoctor = sessionStorage.getItem("selectedDoctor")
      ? JSON.parse(sessionStorage.getItem("selectedDoctor"))
      : null;
    setCurrentDoctor(currentDoctor);
    setIsLoading(true);
    const query_parameters = {
      user_id: currentDoctor?.basic_details?.id,
      organization_id: orgId,
      num_days: "30",
    };
    const res = await getAvailDates(query_parameters);
    setAvailDates(res?.data?.result?.available_dates);
    setSelectedDate(res?.data?.result?.available_dates[0] ? new Date(res?.data?.result?.available_dates[0]) : null);

    setIsLoading(false);
  };
  useEffect(() => {
    console.log(selectedAppointment?.appointment_type)
    setSelectedType(selectedAppointment?.appointment_type)
  }, [selectedAppointment]);
  useEffect(() => {
    if (selectedDate) {
      sessionStorage.setItem("selectedDate", JSON.stringify(selectedDate));
      sessionStorage.setItem("selectedType", JSON.stringify(selectedType));
      fetchAvailSlots(selectedDate);
    }
  }, [selectedDate]);

  const fetchAvailSlots = async (date) => {
    // setIsLoading(true);
    const query_parameters = {
      user_id: currentDoctor?.basic_details?.id,
      organization_id: id,
      date: dateConvert(date),
    };
    const res = await getAvailSlots(query_parameters);
    // console.log(res?.data?.result, "result");
    setTimeSlots(res?.data?.result?.available_slots || []);
    // setIsLoading(false);
  };
  const handleOnSelect = (date) => {
    setSelectedDate(endOfDay(date));
    // setDate(date)
    setIsPopoverOpen(false);
  };
  const isDateDisabled = (date) => {
    return !availDates.some((allowedDate) => {
      return (
        format(new Date(allowedDate), "yyyy-MM-dd") ===
        format(date, "yyyy-MM-dd")
      );
    });
  };
  const handleDate = (date) => {
    setSelectedDate(date);
    // sessionStorage.setItem("selectedDate", JSON.stringify(date));
    // if (date) fetchAvailSlots(date);
  };
  const handleTime = (time, itemRef) => {
    sessionStorage.setItem("selectedTime", JSON.stringify(time));

    setSelectedTime(time);
  };
  const handleSelectAppointment = (type) => {
    sessionStorage.setItem("selectedType", JSON.stringify(type));
    setSelectedType(type);
  };

  useEffect(() => {
    if (selectedDateRef.current) {
      selectedDateRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedDate]);
  useEffect(() => {
    if (selectedTimeRef.current) {
      selectedTimeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedTime]);
  const StarRating = ({ rating, totalStars = 5 }) => {
    return (
      <div>
        {/* {[...Array(totalStars)].map((_, index) => (
          <Star key={index} selected={index < rating} />
        ))} */}
        <span style={{ color: "orange", fontSize: "20px" }}>&#9733;</span>
        <span className="pl-2 pr-[2px]">{rating}</span>{" "}
        <span className="">Rating</span>
      </div>
    );
  };
  const gotoAppointmentSummary = () => {
    if ( selectedDate && selectedTime) {
      setSelectedAppointment({
        ...selectedAppointment,
        date: dateConvert(new Date(selectedDate)),
        start_time: selectedTime.slot_start,
        end_time: selectedTime.slot_end,
      });
      navigate(`/appointmentSummary/${id}`);
    }
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="bg-white min-sh-screen ">
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="#" onClick={handleGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-sm">Back</h4>
              </div>
            </Link>
          </div>
        </div>
        <div
          className=" flex-1 overflow-hidden hideScroll  text-gray-500  flex flex-col py-16 p-4 "
          // style={{ height: "calc(100vh - 30px)" }}
        >
          {currentDoctor && !isLoading && (
            <>
              <div className="flex flex-col w-full  p-2 mt-1  shadow bg-neutral-100 rounded-[18px] border">
                <div className="flex flex-row gap-4">
                  <div className="w-[100px] h-[100px] rounded-full overflow-hidden">
                    {currentDoctor?.basic_details?.profile.avatar_url ? (
                      <img
                        className="w-full h-full object-cover"
                        src={currentDoctor?.basic_details?.profile.avatar_url}
                        alt={currentDoctor?.basic_details?.username}
                      />
                    ) : (
                      <img
                        className="w-full h-full object-cover"
                        src={"../../../images/user.svg"}
                        alt={currentDoctor?.basic_details?.username}
                      />
                    )}
                  </div>
                  <div className="flex flex-col">
                    <h1 className="text-lg font-bold">
                      {currentDoctor?.basic_details?.name_prefix}{" "}
                      {currentDoctor?.basic_details?.profile.first_name}{" "}
                      {currentDoctor?.basic_details?.profile.middle_name}{" "}
                      {currentDoctor?.basic_details?.profile.last_name}
                    </h1>

                    <div className="flex">
                      {currentDoctor?.basic_details?.qualifications &&
                        currentDoctor?.basic_details?.qualifications.map(
                          (qualification, index) => (
                            <div key={index}>
                              <span
                                key={index}
                                className="text-neutral-500 text-sm font-normal"
                              >
                                {qualification}
                              </span>{" "}
                              {index <
                                currentDoctor?.basic_details?.qualifications
                                  .length -
                                  1 && <span className="pr-1">,</span>}
                            </div>
                          )
                        )}
                      {currentDoctor?.basic_details?.specialities &&
                        currentDoctor?.basic_details?.specialities.map(
                          (specialty, index) => (
                            <div key={index}>
                                <span className="pr-1">,</span>
                              <span
                                key={index}
                                className="text-neutral-500 text-sm font-normal "
                              >
                                {specialty?.name}
                              </span>{" "}
                              {index <
                                currentDoctor?.basic_details?.specialities
                                  .length -
                                  1 && <span className="pr-1">,</span>}
                            </div>
                          )
                        )}
                    </div>
                    <StarRating
                      rating={currentDoctor?.basic_details?.ratings}
                    />
                  </div>
                </div>
                <div className="w-full h-[0px] border-b-[1px] border-indigo-200 mb-2"></div>
                <div className="mt-4">
                  <div className="font-semibold">Overview</div>
                  <div className=" ">
                    {" "}
                    <span className=" line-clamp-2 text-slate-700 text-base font-normal ">
                      {currentDoctor?.basic_details?.overview?.substring(
                        0,
                        300
                      )}
                    </span>
                    {/* <span className="text-blue-800 text-base font-bold ">More</span> */}
                  </div>
                </div>
              </div>
              <div className=" py-3 mt-1">
                <div className="text-base font-semibold">
                  {locationDetail?.organization_details?.name}
                </div>

                <div className="">
                  <span className="pr-2">
                    {locationDetail?.organization_details?.location}{" "}
                  </span>
                  <span className="pr-2">
                    {locationDetail?.organization_details?.address?.street},
                  </span>
                  <span className="pr-2">
                    {locationDetail?.organization_details?.address?.city},
                  </span>
                  <span className="pr-2">
                    {locationDetail?.organization_details?.address?.state}
                  </span>

                  <span className="pr-2">
                    {locationDetail?.organization_details?.address?.postal_code}
                  </span>
                </div>

                {locationDetail?.organization_details?.contact?.filter(
                  (e) => e.type == "phone"
                ).length > 0 && (
                  <div className="location-phone webmd-row">
                    Tel:{" "}
                    <a
                      href={`tel:${
                        locationDetail?.organization_details?.contact?.find(
                          (contact) => contact.type === "phone"
                        )?.value
                      }`}
                      className=""
                    >
                      {
                        locationDetail?.organization_details?.contact?.find(
                          (contact) => contact.type === "phone"
                        )?.value
                      }
                    </a>
                  </div>
                )}
              </div>
              <div className="pt-5">
                  <div className="text-lg font-semibold mb-2">
                    Appointment Type
                  </div>
                  <div
                          className={`flex items-center cursor-pointer  text-sm text-white  py-1 px-2 rounded-xl border w-[120px] ${
                            selectedType == "virtual_visit"
                              ? "bg-green-500  border-green-500"
                              : "bg-orange-500 border-orange-500"
                          }`}
                         
                        >
                          {selectedType == "virtual_visit" ? (
                            <CamIcon />
                          ) : (
                            <HospitalIcon />
                          )}{" "}
                          <p className="px-1">
                            {selectedType == "virtual_visit"
                              ? "Video call"
                              : "In Person"}
                          </p>
                        </div>
                </div>
              <div className=" relative pt-2 pb-1 ">
                <p className="font-semibold text-lg pb-2">Select Date</p>

                <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
                  <PopoverTrigger asChild>
                    <button
                      variant={"outline"}
                      className={cn(
                        "border border-input ",
                        "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
                        "w-[280px] justify-start text-left font-normal",
                        "h-10 px-4 py-2 w-full max-w-[389px] mb-3",
                        !selectedDate && "text-muted-foreground"
                      )}
                    >
                      <CalendarIcon className="mr-2 h-4 w-4" />
                      {selectedDate ? (
                        format(selectedDate, "PPP")
                      ) : (
                        <span>Pick a selectedDate</span>
                      )}
                    </button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0">
                    <Calendar
                      mode="single"
                      selected={selectedDate}
                      // onSelect={setDate}
                      onSelect={handleOnSelect}
                      initialFocus
                      className="rounded-md border shadow"
                      disabled={(selectedDate) =>
                        // (selectedDate > addDays(new Date(), 30) || selectedDate <  subDays(new Date() , 1))
                        isDateDisabled(selectedDate)
                      }
                    />
                  </PopoverContent>
                </Popover>
                {/* {availDates?.length > 0 && (
                  <p className="font-semibold text-lg pb-2">Select Schedule</p>
                )} */}
                <div className="flex flex-row gap-2 w-full overflow-y-auto   hideScroll">
                  {availDates?.length > 0 &&
                    availDates.map((e, index) => {
                      const isDateSelected =
                        new Date(e).toDateString() ===
                        new Date(selectedDate).toDateString();
                      return (
                        <div
                          key={index}
                          ref={isDateSelected ? selectedDateRef : null}
                          className={`flex flex-col border  text-center shadow rounded-lg  justify-center items-center cursor-pointer ${
                            isDateSelected ? "bg-primary text-white" : ""
                          } `}
                          onClick={() => handleDate(new Date(e))}
                        >
                          <div className="flex flex-col gap-1 font-semibold justify-center items-center w-[69px] h-[100px]">
                            <p className=" font-semibold text-lg">
                              {" "}
                              {format(new Date(e), "dd")}
                            </p>
                            <p className="text-base">
                              {" "}
                              {format(new Date(e), "eee")}
                            </p>
                            <p className="text-sm">
                              {" "}
                              {format(new Date(e), "MMM")}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {timeSlot?.length > 0 && (
                  <p className="font-semibold text-lg py-2">Available Slot</p>
                )}

                <div className="  gap-3 grid grid-cols-3 sm:grid-cols-4">
                  {timeSlot.map((e, index) => {
                    const isTimeSelected =
                      selectedTime?.slot_start === e?.slot_start;
                    return (
                      <div
                        ref={isTimeSelected ? selectedTimeRef : null}
                        key={index}
                        className={`flex flex-grow   border  text-center shadow rounded-lg p-3 justify-center items-center cursor-pointer ${
                          isTimeSelected ? "bg-primary text-white" : ""
                        } `}
                        onClick={() => handleTime(e)}
                      >
                        <div className="flex flex-row gap-2 font-medium">
                          <p> {format(new Date(e.slot_start), "h:mm a")}</p>{" "}
                          {/* <p>-</p>
                          <p> {format(new Date(e.slot_end), "h:mm a")}</p> */}
                        </div>
                      </div>
                    );
                  })}
                </div>

                
              </div>
            </>
          )}
          {isLoading && (
            <>
              <div className=" w-full bg-white p-2 mt-1 rounded shadow">
                <div className="animate-pulse flex flex-row cursor-pointer p-4 w-full  items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                  <div className=" w-[80px] h-[80px] rounded-full flex-shrink-0  bg-slate-200"></div>
                  <div className="flex flex-col w-full">
                    <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    <div className="m-2  w-full  bg-slate-200 h-4"></div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <div className="mb-4 text-xs border-b  mt-2 bg-white rounded shadow">
                  <div className="animate-pulse flex flex-col cursor-pointer p-1 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className=" w-full  bg-slate-200 h-8"></div>
                  </div>
                </div>

                <div
                  className="overflow-scroll hideScroll flex flex-col gap-3"
                  style={{ height: "calc(100vh - 250px)" }}
                >
                  <div className="animate-pulse flex flex-col  cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    <div className="m-2  w-full  bg-slate-200 h-4"></div>
                  </div>
                  <div className="animate-pulse flex flex-col cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
                    <div className="m-2 w-full  bg-slate-200 h-4"></div>
                    <div className="m-2  w-full  bg-slate-200 h-4"></div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="bg-white h-16 fixed bottom-0 w-full pt-1 flex justify-center">
          <button
            onClick={gotoAppointmentSummary}
            className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
          >
            Book appointment
          </button>
        </div>
      </div>
    </>
  );
}
